// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const fr = {
  demo: {
    title: `France`,
    introduction: `Le Lorem Ipsum est simplement du faux texte employé dans la composition et la mise en page avant impression. Le Lorem Ipsum est le faux texte standard de l'imprimerie depuis les années 1500, quand un imprimeur anonyme assembla ensemble des morceaux de texte pour réaliser un livre spécimen de polices de texte. Il n'a pas fait que survivre cinq siècles, mais s'est aussi adapté à la bureautique informatique, sans que son contenu n'en soit modifié. Il a été popularisé dans les années 1960 grâce à la vente de feuilles Letraset contenant des passages du Lorem Ipsum, et, plus récemment, par son inclusion dans des applications de mise en page de texte, comme Aldus PageMaker.`,
  },
  docs: {
    hi: `Bonjour`,
    description: `Besoin d'aide? \n Consultez notre documentation.`,
    documentation: `documentation`,
  },
  app: `application`,
  user: `utilisateur`,
  list: `liste`,
  edit: `éditer`,
  shop: `boutique`,
  blog: `blog`,
  post: `poste`,
  mail: `e-mail`,
  chat: `discuter`,
  cards: `cartes`,
  posts: `des postes`,
  create: `créer`,
  kanban: `kanban`,
  general: `général`,
  banking: `bancaire`,
  booking: `réservation`,
  profile: `profil`,
  account: `compte`,
  product: `produit`,
  invoice: `facture`,
  details: `détail`,
  checkout: `vérifier`,
  calendar: `calendrier`,
  analytics: `analytique`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `niveau menu`,
  menu_level_2a: `niveau menu 2a`,
  menu_level_2b: `niveau menu 2b`,
  menu_level_3a: `niveau menu 3a`,
  menu_level_3b: `niveau menu 3b`,
  menu_level_4a: `niveau menu 4a`,
  menu_level_4b: `niveau menu 4b`,
  item_disabled: `élément désactivé`,
  item_label: `étiquette de l'article`,
  item_caption: `légende de l'article`,
  item_external_link: `lien externe de l'article`,
  description: `la description`,
  other_cases: `autres cas`,
  item_by_roles: `élément par rôles`,
  only_admin_can_see_this_item: `seul l'administrateur peut voir cet élément`,
  auth: {
    login: 'Connexion',
    email_address: 'Adresse e-mail',
    password: 'Mot de passe',
    forgot_password: 'Mot de passe oublié ?',
    forgot_password_desc: "Veuillez saisir l'adresse e-mail associée à votre compte et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    return_to_login: 'Retour à la connexion',
    email_required: "L'adresse e-mail est obligatoire",
    email_valid: "L'adresse e-mail doit être valide",
    password_required: 'Le mot de passe est obligatoire',
    password_min_length: 'Le mot de passe doit contenir au moins 6 caractères',
    confirm_password_required: 'La confirmation du mot de passe est obligatoire',
    passwords_must_match: 'Les mots de passe doivent correspondre',
    code_required: 'Le code est obligatoire',
    update_password: 'Mettre à jour le mot de passe',
    resend_code: 'Renvoyer le code',
    request_sent_success: 'Demande envoyée avec succès !',
    request_error: "Une erreur est survenue lors de l'envoi de la demande.",
    error_sending: "Erreur lors de l'envoi",
    password_changed: 'Mot de passe modifié avec succès !',
    invalid_code: 'Code invalide',
    code_expired: 'Code expiré',
    generic_error: 'Une erreur est survenue',
    new_password_title: 'Demande envoyée avec succès !',
    new_password_desc: 'Nous avons envoyé un e-mail de confirmation à 6 chiffres à votre adresse e-mail. Veuillez saisir le code ci-dessous pour vérifier votre e-mail.',
    send_request: 'Envoyer la demande',
    confirm_password: 'Confirmer le nouveau mot de passe',
    reset_password: 'Réinitialiser le mot de passe',
    new_password: 'Nouveau mot de passe',
  },
};

export default fr;
